module.exports = __webpack_public_path__ + "static/img/img7.f4c19ded.png";